<template>
  <generic-modal :title="$t('customer')" ref="generic_modal">
    <!-- Customer Form -->
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("customer name") }}</label>
          <div class="control">
            <input
              class="input"
              type="text"
              v-model="meta.name"
              :placeholder="$t('customer name')"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("identification number") }}</label>
          <div class="control">
            <input
              class="input"
              type="text"
              v-model="meta.identification_number"
              :placeholder="$t('identification number')"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Error handling -->
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>

    <!-- Footer buttons -->
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon"><i class="fa fa-save"></i></span>
        <span>{{ $t("save") }}</span>
      </button>
      <button
        class="button is-danger is-rounded"
        @click="remove"
        v-if="meta.uuid"
      >
        <span class="icon"><i class="fa fa-trash"></i></span>
        <span>{{ $t("delete") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon"><i class="fa fa-close"></i></span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>

<script>
import {
  put,
  post,
  del,
  get,
  generate_error_message_text,
  confirm_deletion_dialog,
  success_message,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "CustomerModal",
  components: { GenericModal },
  data() {
    return {
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      return !this.meta.name || !this.meta.identification_number;
    },
  },
  methods: {
    close_modal() {
      this.$refs.generic_modal.close_modal();
      this.set_initial_state();
    },

    show_modal(uuid = null) {
      this.set_initial_state();

      if (uuid) {
        get("/archive/customer", { uuid })
          .then((customer) => {
            this.meta = customer;
            this.$refs.generic_modal.show_modal();
          })
          .catch((error) => {
            this.error = generate_error_message_text(error);
          });
      } else {
        this.$refs.generic_modal.show_modal();
      }
    },

    save() {
      const isEdit = !!this.meta.uuid;
      const method = isEdit ? post : put;
      const endpoint = "/archive/customer";

      method(endpoint, this.meta)
        .then(() => {
          this.$emit("success");
          success_message(this.$t("record saved"));
          this.$refs.generic_modal.close_modal();
        })
        .catch((error) => {
          this.error = generate_error_message_text(error);
        });
    },

    remove() {
      confirm_deletion_dialog(
        this.$t("are you sure delete customer"),
        this,
        () => {
          del("/archive/customer", { uuid: this.meta.uuid })
            .then(() => {
              this.$emit("success");
              success_message(this.$t("record deleted"));
              this.$refs.generic_modal.close_modal();
            })
            .catch((error) => {
              this.error = generate_error_message_text(error);
            });
        }
      );
    },

    set_initial_state() {
      this.meta = {
        name: "",
        identification_number: "",
      };
      this.error = "";
    },
  },
};
</script>
